import { css, keyframes } from '@emotion/core';

const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translate(-100%, 0) scale(0.95);
  }
  to {
    opacity: 1;
    transform: translate(-100%, 8px) scale(1);
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
    transform: translate(-100%, 8px) scale(1);
  }
  to {
    opacity: 0;
    transform: translate(-100%, 0) scale(0.95);
  }
`;

export const trigger = css`
  display: inline-flex;
  cursor: pointer;
`;

export const popover = (state: 'open' | 'close') => css`
  position: fixed;
  width: 260px;

  background: #ffffff;
  border-radius: 6px;
  border: 1px solid #a3a6abff;
  box-shadow: 0 10px 15px rgba(0, 0, 0, 0.15);

  z-index: 999999;
  padding-top: 12px;
  padding-bottom: 12px;

  animation: ${state === 'open' ? fadeIn : fadeOut} ${state === 'open' ? '150ms' : '50ms'} ease-out forwards;
  transform-origin: top right;
`;

export const arrow = css`
  position: absolute;
  top: -5px;
  right: 6px;

  width: 8px;
  height: 8px;

  background: white;
  border-left: 1px solid #a3a6abff;
  border-top: 1px solid #a3a6abff;

  transform: rotate(45deg);
`;

export const body = css`
  font-size: 14px;
  color: #4a5568;
  margin-bottom: 12px;
  padding: 0 12px;
`;

export const footer = css`
  display: flex;
  justify-content: flex-end;
  gap: 8px;
  margin-top: 12px;
  padding: 0 12px;
`;
